import React, { useEffect } from "react";
import { connect } from "react-redux";
import TransportersComponent from "./TransportersComponent";
import { TransportersFunction } from "../../redux/index";
import { useParams } from "react-router";
import { EndPoints } from "../../utils/EndPoints";

function TransportersContainer(props) {
  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = () => {
    props.TransportersFunction("get", EndPoints["TransportersList"]);
  };

  const { tab, id } = useParams();
  const params = { tab: tab, id: id };
  return <TransportersComponent {...props} params={params} />;
}

const mapStateToProps = (state) => ({
  user: state.authentication.user,
  loading: state.modules.loading,
  [EndPoints["TransportersList"]]: state.modules[EndPoints["TransportersList"]],
});
const mapDispatchToProps = {
  TransportersFunction,
};

export default connect(mapStateToProps, mapDispatchToProps)(TransportersContainer);
